import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Spinner } from "reactstrap";
import "../../styles/businessBackofficeStyles.scss";
import { getInternalMessages } from "../../../ApiCalls/mantisBusiness";
import { selectAuthState } from "../../../store/selectors/authSelectors";

function Inbox(props) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    setLoading(true);
    const response = await getInternalMessages(
      props.mantisBusiness._id,
      props.token,
      props.user._id
    );
    if (response.success) {
      // Ordenar los mensajes por fecha de creación, de más reciente a más antigua
      const sortedMessages = [...response.receivedMessages, ...response.sentMessages].sort((a, b) => {
        const dateA = new Date(a.dateCreated);
        const dateB = new Date(b.dateCreated);
        return dateB - dateA; // Ordenar de más reciente a más antigua
      });
      setMessages(sortedMessages);
    } else {
      alert("Error al obtener los datos");
    }
    setLoading(false);
  };

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <div
        style={{
          padding: "20px 24px 16px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
          background:
            "linear-gradient(135deg, rgba(249, 115, 22, 0.1) 0%, rgba(234, 88, 12, 0.05) 100%)",
        }}
      >
        <h1
          style={{
            color: "white",
            fontSize: "1.5rem",
            fontWeight: "700",
            margin: "0",
            fontFamily: "Poppins, sans-serif",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <span style={{ fontSize: "1.2em" }}>🔔</span>
          Notificaciones
        </h1>
        {messages.length > 0 && (
          <p
            style={{
              color: "rgba(255, 255, 255, 0.7)",
              fontSize: "0.9rem",
              margin: "8px 0 0 0",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {messages.length}{" "}
            {messages.length === 1 ? "notificación" : "notificaciones"}
          </p>
        )}
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Spinner color="white" />
            <p
              style={{
                color: "rgba(255, 255, 255, 0.7)",
                fontFamily: "Poppins, sans-serif",
                margin: "0",
              }}
            >
              Cargando notificaciones...
            </p>
          </div>
        ) : (
          <div>
            {messages.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "200px",
                  padding: "20px",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "3rem",
                    marginBottom: "16px",
                    opacity: 0.5,
                  }}
                >
                  📭
                </div>
                <h2
                  style={{
                    fontSize: "1.2rem",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: "500",
                    color: "rgba(255, 255, 255, 0.8)",
                    margin: "0 0 8px 0",
                  }}
                >
                  No hay notificaciones
                </h2>
                <p
                  style={{
                    fontSize: "0.9rem",
                    fontFamily: "Poppins, sans-serif",
                    color: "rgba(255, 255, 255, 0.6)",
                    margin: "0",
                  }}
                >
                  Te notificaremos cuando tengas nuevos mensajes
                </p>
              </div>
            ) : (
              messages.map((message, index) => (
                <div
                  key={index}
                  className="internal-message-card"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <div className="message-icon">{message.icon || "📧"}</div>
                  <div className="message-content">
                    <div className="internal-message-subject">
                      {message.subject}
                    </div>
                    <div className="internal-message-preview">
                      {message.message}
                    </div>
                    <div className="internal-message-meta">
                      <span className="sender-info">
                        De: {message.toEmails.join(", ")}
                      </span>
                      <span className="date-info">
                        {new Date(message.dateCreated).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default connect(selectAuthState)(Inbox);